module.exports = __webpack_public_path__ + "img/botaovarginhasetcemg.3f23b47d.png";